import { NavLink } from 'react-router-dom';

interface NavItem {
  label: string;
  path: string;
  icon: string;
}

interface NavSection {
  title: string;
  items: NavItem[];
}

const NAV_SECTIONS: NavSection[] = [
  {
    title: 'Operasyon',
    items: [
      { label: 'Genel Bakış', path: '/', icon: 'ri-dashboard-line' },
      { label: "Bugünün İşleri", path: '/bugunun-isleri', icon: 'ri-calendar-check-line' },
      { label: 'Teklif Talepleri', path: '/teklif-talepleri', icon: 'ri-file-list-3-line' },
      { label: 'Teklifler', path: '/teklifler', icon: 'ri-file-text-line' },
      { label: 'Randevu & Takvim', path: '/randevu', icon: 'ri-calendar-line' },
      { label: 'Aktif İşler', path: '/aktif-isler', icon: 'ri-tools-line' },
    ],
  },
  {
    title: 'Müşteri',
    items: [
      { label: 'Müşteriler', path: '/musteriler', icon: 'ri-user-line' },
      { label: 'Takip Gerekenler', path: '/takip', icon: 'ri-notification-3-line' },
      { label: 'Tamamlanan İşler', path: '/tamamlanan-isler', icon: 'ri-check-double-line' },
    ],
  },
  {
    title: 'Finans',
    items: [
      { label: 'Tahsilatlar', path: '/tahsilatlar', icon: 'ri-wallet-3-line' },
      { label: 'Gelir & Gider', path: '/finans', icon: 'ri-funds-box-line' },
    ],
  },
  {
    title: 'Yönetim',
    items: [
      { label: 'Ekipler', path: '/ekipler', icon: 'ri-group-line' },
      { label: 'Raporlar', path: '/raporlar', icon: 'ri-bar-chart-line' },
      { label: 'Ayarlar', path: '/ayarlar', icon: 'ri-settings-3-line' },
    ],
  },
];

export default function Sidebar() {
  return (
    <aside className="fixed inset-y-0 left-0 z-40 flex w-[264px] flex-col bg-primary-950">
      {/* Brand */}
      <div className="flex items-center gap-3 px-6 py-6">
        <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500 text-primary-950">
          <i className="ri-sparkling-2-fill text-xl" />
        </div>
        <div className="leading-tight">
          <div className="text-[15px] font-extrabold tracking-tight text-white">VİAYPİİ</div>
          <div className="text-[11px] font-medium tracking-[0.18em] text-accent-400">TEMİZLİK</div>
        </div>
      </div>

      {/* Nav */}
      <nav className="flex-1 overflow-y-auto px-3 pb-6">
        {NAV_SECTIONS.map((section) => (
          <div key={section.title} className="mb-6">
            <div className="px-3 pb-2 text-[11px] font-semibold uppercase tracking-[0.14em] text-primary-300/70">
              {section.title}
            </div>
            <ul className="space-y-0.5">
              {section.items.map((item) => (
                <li key={item.path}>
                  <NavLink
                    to={item.path}
                    end={item.path === '/'}
                    className={({ isActive }) =>
                      `group flex items-center gap-3 rounded-lg px-3 py-2.5 text-[13.5px] font-medium transition-colors ${
                        isActive
                          ? 'bg-primary-800/70 text-white'
                          : 'text-primary-200/80 hover:bg-primary-800/40 hover:text-white'
                      }`
                    }
                  >
                    {({ isActive }) => (
                      <>
                        <i
                          className={`${item.icon} text-[17px] ${
                            isActive ? 'text-accent-400' : 'text-primary-300/60 group-hover:text-primary-200'
                          }`}
                        />
                        <span className="whitespace-nowrap">{item.label}</span>
                        {isActive && (
                          <span className="ml-auto h-1.5 w-1.5 rounded-full bg-accent-400" />
                        )}
                      </>
                    )}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </nav>

      {/* Footer / user */}
      <div className="border-t border-primary-800/60 px-4 py-4">
        <div className="flex items-center gap-3">
          <div className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-700 text-sm font-bold text-accent-400">
            BY
          </div>
          <div className="min-w-0 flex-1">
            <div className="truncate text-[13px] font-semibold text-white">Burak Yıldız</div>
            <div className="truncate text-[11px] text-primary-300/60">Operasyon Yöneticisi</div>
          </div>
          <i className="ri-more-2-fill text-primary-300/60" />
        </div>
      </div>
    </aside>
  );
}